import { StyleSheet } from '@react-pdf/renderer';

export const pdfStyles = StyleSheet.create({
  page: {
    padding: 32,
    fontSize: 9,
    color: '#1f2a44',
    fontFamily: 'Helvetica',
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 24,
    paddingBottom: 14,
    borderBottomWidth: 1,
    borderBottomColor: '#d8e0eb',
  },
  logo: {
    width: 92,
    height: 34,
    borderWidth: 1,
    borderColor: '#9bb4d3',
    color: '#4b78a8',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    fontWeight: 700,
  },
  title: {
    fontSize: 18,
    fontWeight: 700,
    marginBottom: 4,
  },
  sectionTitle: {
    fontSize: 12,
    fontWeight: 700,
    marginBottom: 8,
    marginTop: 12,
  },
  muted: {
    color: '#66758b',
  },
  table: {
    borderWidth: 1,
    borderColor: '#d8e0eb',
  },
  row: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#d8e0eb',
  },
  headerCell: {
    backgroundColor: '#eef4fb',
    fontWeight: 700,
  },
  cell: {
    padding: 5,
    borderRightWidth: 1,
    borderRightColor: '#d8e0eb',
    minHeight: 24,
  },
  notes: {
    marginTop: 3,
    color: '#66758b',
    fontSize: 8,
  },
  image: {
    width: 42,
    height: 32,
    marginTop: 3,
    objectFit: 'cover',
  },
  totals: {
    marginTop: 14,
    alignSelf: 'flex-end',
    width: 220,
    borderWidth: 1,
    borderColor: '#d8e0eb',
  },
  totalRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    padding: 6,
    borderBottomWidth: 1,
    borderBottomColor: '#d8e0eb',
  },
  totalFinal: {
    fontWeight: 700,
    backgroundColor: '#eef4fb',
  },
  footer: {
    position: 'absolute',
    bottom: 22,
    left: 32,
    right: 32,
    flexDirection: 'row',
    justifyContent: 'space-between',
    color: '#66758b',
    fontSize: 8,
    borderTopWidth: 1,
    borderTopColor: '#d8e0eb',
    paddingTop: 8,
  },
});
